const one = (count, singular, plural) => `${count} ${Number(count) === 1 ? singular : plural}`;

const copy = {
  es: {
    connection: (n) => `Tu plan incluye ${one(n, "conexión", "conexiones")}.`,
    queue: (n) => `Tu plan incluye ${one(n, "departamento", "departamentos")}.`,
    users: (n) => `Tu plan incluye ${one(n, "usuario", "usuarios")}, contándote a ti.`,
    campaigns: (plan) => `Tu plan permite ${one(plan.maxCampaignsPerDay, "campaña al día", "campañas al día")}, ${one(plan.maxActiveCampaigns, "activa a la vez", "activas a la vez")} y hasta ${plan.maxCampaignContacts} contactos por envío. El intervalo mínimo entre mensajes es ${plan.campaignMinInterval} segundos.`,
    status: (n) => `Tu plan incluye ${one(n, "publicación al día", "publicaciones al día")}.`,
    included: (name) => `${name} está incluido en tu plan.`,
  },
  en: {
    connection: (n) => `Your plan includes ${one(n, "connection", "connections")}.`,
    queue: (n) => `Your plan includes ${one(n, "department", "departments")}.`,
    users: (n) => `Your plan includes ${one(n, "user", "users")}, including you.`,
    campaigns: (plan) => `Your plan allows ${one(plan.maxCampaignsPerDay, "campaign per day", "campaigns per day")}, ${one(plan.maxActiveCampaigns, "active at a time", "active at a time")} and up to ${plan.maxCampaignContacts} contacts per send. The minimum interval between messages is ${plan.campaignMinInterval} seconds.`,
    status: (n) => `Your plan includes ${one(n, "status post per day", "status posts per day")}.`,
    included: (name) => `${name} is included in your plan.`,
  },
  pt: {
    connection: (n) => `Seu plano inclui ${one(n, "conexão", "conexões")}.`,
    queue: (n) => `Seu plano inclui ${one(n, "departamento", "departamentos")}.`,
    users: (n) => `Seu plano inclui ${one(n, "usuário", "usuários")}, contando você.`,
    campaigns: (plan) => `Seu plano permite ${one(plan.maxCampaignsPerDay, "campanha por dia", "campanhas por dia")}, ${one(plan.maxActiveCampaigns, "ativa por vez", "ativas por vez")} e até ${plan.maxCampaignContacts} contatos por envio. O intervalo mínimo entre mensagens é ${plan.campaignMinInterval} segundos.`,
    status: (n) => `Seu plano inclui ${one(n, "publicação por dia", "publicações por dia")}.`,
    included: (name) => `${name} está incluído no seu plano.`,
  },
};

const names = {
  es: { kanban: "Kanban", ai: "Agentes IA", schedules: "Mensajes programados", chat: "Chat interno", agenda: "Agenda", files: "Archivos", groups: "Campañas en grupos", flows: "Flujos", integrations: "Integraciones", api: "API externa", negocio: "Negocio", csat: "La evaluación de atención", quick: "Respuestas rápidas", tags: "Etiquetas" },
  en: { kanban: "Kanban", ai: "AI agents", schedules: "Scheduled messages", chat: "Internal chat", agenda: "Appointments", files: "Files", groups: "Group campaigns", flows: "Flows", integrations: "Integrations", api: "External API", negocio: "Business", csat: "Support rating", quick: "Quick replies", tags: "Tags" },
  pt: { kanban: "Kanban", ai: "Agentes IA", schedules: "Mensagens agendadas", chat: "Chat interno", agenda: "Agenda", files: "Arquivos", groups: "Campanhas em grupos", flows: "Fluxos", integrations: "Integrações", api: "API externa", negocio: "Negócio", csat: "A avaliação do atendimento", quick: "Respostas rápidas", tags: "Etiquetas" },
};

export function guidePlanHint(plan, id, language = "es") {
  if (!plan) return "";
  const locale = String(language || "es").slice(0, 2);
  const text = copy[locale] || copy.es;
  const label = (names[locale] || names.es)[id];
  if (id === "connection" || id === "assignment") return Number(plan.connections) > 0 ? text.connection(plan.connections) : "";
  if (id === "queue" || id === "greeting") return Number(plan.queues) > 0 ? text.queue(plan.queues) : "";
  if (id === "invite" || id === "roles") return Number(plan.users) > 0 ? text.users(plan.users) : "";
  if (id === "campaigns" || id === "groups") {
    const ready = ["maxCampaignsPerDay", "maxActiveCampaigns", "maxCampaignContacts", "campaignMinInterval"].every((key) => plan[key] != null && plan[key] !== "");
    if (ready) return text.campaigns(plan);
    const fallback = { es: "Campañas", en: "Campaigns", pt: "Campanhas" };
    return text.included(fallback[locale] || fallback.es);
  }
  if (id === "status") return Number(plan.maxStatusCampaignsPerDay) > 0 ? text.status(plan.maxStatusCampaignsPerDay) : "";
  if (["payments", "products", "suppliers", "accounts", "customers", "sales", "collections", "messages", "codes", "bot", "agent", "loyalty"].includes(id)) {
    return text.included(locale === "en" ? "Business" : locale === "pt" ? "Negócio" : "Negocio");
  }
  return label ? text.included(label) : "";
}

export const guideImage = (id) => {
  const file = {
    greeting: "queue",
    assignment: "connection",
    roles: "invite",
  }[id] || id;
  return `/guides/${file}.jpg`;
};
